import axios from "axios";
import UrlAPI from '../../components/UrlAPI';

export const VALIDACAO_STATUS = "VALIDACAO_STATUS";
export const VALIDACAO_MSG = "VALIDACAO_MSG";

export const VALIDACAO_UNICA = "VALIDACAO_UNICA";
export const CERTIFICADO_INFOS = "CERTIFICADO_INFOS";


export default class ValidadorApi {
  static validarDocumentoPorCertificado(values, resolve, reset) {
    return dispatch => {
      axios.post(`${UrlAPI.getUrl()}/public/cie/status`, {"certificado": values})
        .then(res => {
          window.grecaptcha.reset();

          dispatch(reset("formValidadorPorCertificado"));
          resolve();
          switch (res.data.statusRetorno) {
            case "OK" :
              dispatch({type: VALIDACAO_STATUS, payload: true});
              dispatch({type: VALIDACAO_MSG, payload: `Certificado Válido`});
              break;
            case "EXPIRADO" :
              dispatch({type: VALIDACAO_STATUS, payload: true});
              dispatch({type: VALIDACAO_MSG, payload: `Certificado Expirado`});
              break;
            case "REVOGADO" :
              dispatch({type: VALIDACAO_STATUS, payload: true});
              dispatch({type: VALIDACAO_MSG, payload: `Certificado Revogado`});
              break;
            default :
              dispatch({type: VALIDACAO_STATUS, payload: false});
              dispatch({type: VALIDACAO_MSG, payload: res.data.msg || "Certificado Inválido"});
              break;
          }
        })
        .catch(err => {
          console.log(err);
          dispatch({type: VALIDACAO_STATUS, payload: false});
          dispatch({
            type: VALIDACAO_MSG,
            payload: err.response.data ? err.response.data.statusRetorno === "INEXISTENTE" ? "Certificado Inexistente" : "Certificado Inválido" : 'Não foi possível validar a CIE'
          });
          resolve();
        })
    }
  }
}

export const validarCiePelaUrl = (values) => {
  return dispatch => {
    let d = new Date();
    values.nomeEvento = "meiaentrada";
    values.dataEvento = `${d.getFullYear()}${(`0${(d.getMonth()+1)}`).slice(-2)}${(`0${d.getDate()}`).slice(-2)}`;
    values.cnpjPromotor = "00000000000000";

    console.log(values);

    axios({
      method: 'POST',
      url: "https://api-prod.meiaentrada.org.br/public/validador",
      data: values,
      headers: {
        'Content-Type': 'application/json',
        'codigoAcesso': '4807689a'
      },
      json: true
    })
      .then(res => {
        let data = res.data;
        let infos = undefined;
        if (data.status === "true" || data.status === true) {
          infos = {
            nome: data.nome,
            nomeSocial: data.nomeSocial,
            documento: data.documento,
            instituicao: data.instituicao,
            curso: data.curso,
            entidade: data.entidade,
            foto: data.foto,
            certificado: data.certificado
          }
        }
        dispatch({type: VALIDACAO_UNICA, payload: true});
        dispatch({type: CERTIFICADO_INFOS, payload: infos})
      })
      .catch(() => {
        dispatch({type: VALIDACAO_UNICA, payload: true});
        dispatch({type: CERTIFICADO_INFOS, payload: undefined})
      })
  }
};


// WEBPACK FOOTER //
// ./src/logicas/Validador/ValidadorApi.js